import React from "react";

const ProjectSelfHelp = () => {
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        backgroundImage:
          "url('../../images/frames/2960875-hd_1920_1080_30fps.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        poster={require("../../images/frames/2960875-hd_1920_1080_30fps.jpg")}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          filter: "grayscale(100%) brightness(0.3)",
        }}
      >
        <source
          src="https://chenyuzhang-com-assets.s3.us-east-1.amazonaws.com/journaling-videos/2960875-hd_1920_1080_30fps.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div
        style={{
          position: "relative",
          zIndex: 1,
          padding: 32,
          color: "white",
          textShadow: "0 2px 8px rgba(0,0,0,0.7)",
        }}
      >
        <h1>Project: Self Help</h1>
        <p>This is the Self Help project page. Content coming soon!</p>
      </div>
    </div>
  );
};

export default ProjectSelfHelp;
